import React from 'react'
import Home from './pages/Home'

function Layout() {
  return (
    <Home/>
  )
}

export default Layout